
//** This file changes the collection filters to be sticky when scrolling up


(() => {
  const stickyBar = window.StickyScrollUp.register({
    selector: '.product-facet__meta-bar',
    spacerClass: 'product-facet__meta-bar-spacer',
    shouldHold: (bar) => bar.classList.contains('has-open-popover'),
  });

  // Flag the bar while a popover inside it is open. On close the flag is held
  // until the popover's slide-out transition finishes: dropping it early
  // restores the bar's will-change, which re-anchors the still-animating fixed
  // sheet to the bar and makes it jump upwards.
  const CLOSE_FALLBACK_MS = 700; // popover transform transition is .6s

  const onPopoverOpen = (event) => {
    const popoverBar = event.target.closest('.product-facet__meta-bar');
    if (!popoverBar || !event.target.classList.contains('popover')) return;
    clearTimeout(event.target._closeTimer);
    popoverBar.classList.add('has-open-popover');
  };

  const onPopoverClose = (event) => {
    const popover = event.target;
    const popoverBar = popover.closest('.product-facet__meta-bar');
    if (!popoverBar || !popover.classList.contains('popover')) return;

    const release = () => {
      clearTimeout(popover._closeTimer);
      popover.removeEventListener('transitionend', onTransitionEnd);
      if (!popover.hasAttribute('open')) popoverBar.classList.remove('has-open-popover');
    };
    const onTransitionEnd = (transitionEvent) => {
      if (transitionEvent.target === popover) release();
    };

    popover.addEventListener('transitionend', onTransitionEnd);
    popover._closeTimer = setTimeout(release, CLOSE_FALLBACK_MS);
  };

  const init = () => {
    document.addEventListener('openable-element:open', onPopoverOpen);
    document.addEventListener('openable-element:close', onPopoverClose);
    // Re-bind whenever the product-facet section re-renders (filter/sort/pagination).
    document.addEventListener('pagination:content-updated', stickyBar.refresh);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
